module.exports = __webpack_public_path__ + "04_glasses_black.b2be679a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/04_glasses_black.png
// module id = eT9L
// module chunks = 0